import { Component, OnInit, Input, EventEmitter, Output,ViewChild, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { MovimientosObraService } from '../../../services/movimientos-obra.service';
import { ObrasService } from '../../../services/obras.service';
import { ProveedoresService } from '../../../services/proveedores.service';
import { CuentasPorCobrarService } from '../../../services/cuentas-por-cobrar.service';
import { HelpersService } from '../../../services/tools/helpers.service';

@Component({
  selector: 'app-modal-seleccion-cxc',
  templateUrl: './modal-seleccion-cxc.component.html',
  styleUrls: ['./modal-seleccion-cxc.component.scss']
})
export class ModalSeleccionCXCComponent implements OnInit {
    @Output() onSelectCuenta: EventEmitter<any> = new EventEmitter;
    //Varias facturas cubiertas por un mismo deposito: salen en un solo complemento de pago
    @Output() onSelectVarias: EventEmitter<any> = new EventEmitter;

    public seleccionadas: any[] = [];
    public avisoSeleccion: string = null;

    @ViewChild('content') private content: TemplateRef<any>;

    public modal: any = null;
    public comprobantes: any[] = [];
    public isEmptyArray: boolean = false;
    public idObraSeleccionada: number = null;

     //filters
     public obra: any = {};
     public proveedor: any = {};
     public proveedorSeleccionado: any = {};
     public fechaTermino: any;
     public searchText: string = null;
     public importe: any = null;
     public incluir_facturadas: boolean = false;
     
     //helpers
     public loading: boolean = true;
     public loading_obras: boolean = false;
     public loading_proveedores: boolean = false;
     public proveedores: any [] = [];

    public cpc: any [] = [];
    errors:any = {};

    constructor(private router: Router,
        private movimientosObraService: MovimientosObraService,
        private proveedoresService: ProveedoresService,
        private cuentasPorCobrarService: CuentasPorCobrarService,
        private helperService: HelpersService,
        private modalService: NgbModal) { }

    ngOnInit() {
        this.getFechaActual();
        this.loadProveedores();
    }

    public openModal(id_obra) {
        //Preseleccionar una obra
        if(id_obra){
            this.idObraSeleccionada = id_obra;
        }

        this.loadCuentas();
        this.modal = this.modalService.open(this.content, { size: 'lg' });
    }

    public closeModal() {
        this.modal.close();
    }

    private loadCuentas(){
        this.loading = true;
        let filtros = this.getFiltros();
        this.cuentasPorCobrarService.getCPCParaMovimientos(this.idObraSeleccionada, filtros)
        .subscribe(response => {
            let content = response.json().content;
            //console.log("content: ",content);
            this.cpc = content;
            this.loading = false;
        },error=>{
            alert("ERROR: "+JSON.stringify(error));
            this.loading = false;
        });
    }

    getFechaActual() {
        this.movimientosObraService.getFechaActual()
            .subscribe((response) => {
                const content = response.json().content;
                this.fechaTermino = content.fecha;
            }, (error) => {
                // se revisan errores 403 - 500
                this.helperService.httpGlobalError(error);

                if (error == 400) {
                console.log('getFechasActual - error 400 ' , error);
                }
            });
    }

    public seleccionarCuenta(c){
        this.onSelectCuenta.emit(c);
        this.modal.close();
    }

    /**
     * Seleccion multiple: un deposito que cubre varias facturas se cobra con un solo
     * complemento de pago, con todas relacionadas. Tienen que ser del mismo cliente, porque
     * un CFDI lleva un solo receptor; que sean del mismo inmueble lo valida el servidor.
     */
    public alternarSeleccion(c, evento?) {
        if (evento) {
            evento.stopPropagation();
        }

        this.avisoSeleccion = null;
        const posicion = this.posicionEnSeleccion(c);

        if (posicion > -1) {
            this.seleccionadas.splice(posicion, 1);
            return;
        }

        if (this.seleccionadas.length > 0 && this.seleccionadas[0].id_proveedor != c.id_proveedor) {
            this.avisoSeleccion = 'Las facturas de un mismo complemento tienen que ser del mismo cliente.';
            return;
        }

        if (c.metodo_pago !== 'PPD') {
            this.avisoSeleccion = 'Solo se pueden agrupar facturas en parcialidades (PPD).';
            return;
        }

        this.seleccionadas.push(c);
    }

    public estaSeleccionada(c): boolean {
        return this.posicionEnSeleccion(c) > -1;
    }

    private posicionEnSeleccion(c): number {
        for (let i = 0; i < this.seleccionadas.length; i++) {
            if (this.seleccionadas[i].id_cuenta_por_cobrar == c.id_cuenta_por_cobrar) {
                return i;
            }
        }

        return -1;
    }

    public totalSeleccionado(): number {
        let total = 0;

        this.seleccionadas.forEach(c => {
            total += parseFloat(c.total_por_cobrar) || 0;
        });

        return total;
    }

    public agregarSeleccionadas() {
        if (this.seleccionadas.length < 2) {
            this.avisoSeleccion = 'Para un pago agrupado hay que elegir al menos dos facturas.';
            return;
        }

        this.onSelectVarias.emit(this.seleccionadas.slice());
        this.limpiarSeleccion();
        this.modal.close();
    }

    public limpiarSeleccion() {
        this.seleccionadas = [];
        this.avisoSeleccion = null;
    }

    private loadProveedores(){
        this.loading_proveedores = true;
        this.proveedoresService.getProveedorestoSelect()
        .subscribe(response => {
            let content = response.json().content;
            this.proveedores = content.proveedores;
            this.loading_proveedores = false;
        },error=>{
            alert("ERROR: "+JSON.stringify(error));
            this.loading_proveedores = false;
        });
    }

    /**
     * Utilities
     */

    private getFiltros(){        
        let filtros = {
            id_proveedor: this.proveedorSeleccionado.idProveedores 
                ? this.proveedorSeleccionado.idProveedores : null,
                fecha_termino: this.fechaTermino ? this.fechaTermino : null,
                search: this.searchText ? this.searchText : null,
                importe: this.importe ? this.importe : null,
                incluir_facturadas: this.incluir_facturadas ? '1' : '0'
        }

        return filtros;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/movimientos-obra/modal-seleccion-cxc/modal-seleccion-cxc.component.ts